import React, { useEffect, useState } from "react";
import { Styles } from "./styles";
import ReactImg from "../../../assets/images/backGrounds/react.svg";
import Tag from "../../../assets/images/backGrounds/tag.svg";
import TrainerBG from "../../../assets/images/backGrounds/TrainersectionBG.svg";
import { Container } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";
import i18next, { t } from "i18next";
import { getAllCoaches } from "../../../services/coach.service";
import Loader from "../../common/loader/Loader";
import Error from "../../common/error/Error";
import { useSelector } from "react-redux";
import { Fade } from "react-reveal";
import RubberBand from "react-reveal/RubberBand";
import Spin from "react-reveal/Spin";
import MainButton from "../../common/buttons/mainButton/MainButton";
import { useNavigate } from "react-router";

const Trainers = () => {
  // language data from store
  const Resource = useSelector((state) => state.translation.resource);
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState();
  const getData = async () => {
    setIsLoading(true);
    try {
      const response = await getAllCoaches();
      if (response?.status === 200) {
        setData(response?.data?.data?.list);
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <Styles>
      {isLoading ? (
        <Loader height={"100%"} />
      ) : (
        data?.length > 0 && (
          <section id="trainerSection">
            <img className="background" src={TrainerBG} alt="background" />
            <Spin>
              <img className="react" src={ReactImg} alt="react image" />
            </Spin>
            <RubberBand>
              <img className="tag" src={Tag} alt="tag image" />
            </RubberBand>
            <Container>
              <Fade bottom>
                <h2 className="section-title">
                  {Resource?.trainers_title
                    ? Resource?.trainers_title
                    : t("home.trainers.title")}
                </h2>
              </Fade>
              <Swiper
                slidesPerView={1}
                spaceBetween={40}
                navigation={true}
                modules={[Navigation]}
                loop={true}
              >
                {data?.map((item, idx) => {
                  return (
                    <SwiperSlide key={idx}>
                      <div
                        onClick={() => {
                          navigate(`/trainer-profile/${item?.id}`);
                        }}
                        className="item-content"
                      >
                        <div className="item-data">
                          <h3 className="item-title">
                            {Resource?.coach
                              ? Resource?.coach
                              : t("home.trainers.coach")}{" "}
                            :{" "}
                            {i18next?.language === "ar"
                              ? item?.fullNameAr
                              : item?.fullNameEn}
                          </h3>
                          <div className="item-info">
                            <div className="item-job-title">
                              {Resource?.job_title
                                ? Resource?.job_title
                                : t("home.trainers.job_title")}{" "}
                              : {item?.specializationLocalizedName}
                            </div>
                            <div className="item-description">
                              {item?.brief?.map((item, idx) => {
                                if (idx < 3) {
                                  return (
                                    <div key={idx}>{item?.description}</div>
                                  );
                                }
                              })}
                              {item?.brief?.length > 3 && (
                                <div className="dots">...</div>
                              )}
                            </div>
                            <div className="more">
                              <MainButton
                                buttonText={t("more")}
                                buttonClick={() => {
                                  navigate(`/trainer-profile/${item?.id}`);
                                }}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="item-img">
                          <img src={item?.avatar} alt={item?.fullNameEn} />
                        </div>
                      </div>
                    </SwiperSlide>
                  );
                })}
              </Swiper>
            </Container>
          </section>
        )
      )}
    </Styles>
  );
};

export default Trainers;
